import { render, staticRenderFns } from "./rickArealist.vue?vue&type=template&id=5f250208&"
import script from "./rickArealist.vue?vue&type=script&lang=js&"
export * from "./rickArealist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports